import ToolbarDropdown from '@/components/TiptapEditor/Toolbar/Dropdowns/ToolbarDropdown';
import { InputAdornment } from '@mui/material';
import BorderStyleIcon from '@mui/icons-material/BorderStyle';
import { findParentNode, useCurrentEditor, useEditorState } from '@tiptap/react';
import React, { useState } from 'react';

const options = ['hidden', 'solid', 'dotted', 'dashed', 'double'].map((key) => ({
	label: key.replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()),
	value: key,
	type: 'borderStyle',
	default: 'solid',
}));

const BorderSelect = React.forwardRef(({ nodeType = 'table' }, ref) => {
	const [open, setOpen] = useState(false);
	const { editor } = useCurrentEditor();

	const { borderStyle } = useEditorState({
		editor,
		selector: (ctx) => {
			const selection = ctx.editor?.state?.selection;
			const currentCell = findParentNode((node) =>
				nodeType === 'table'
					? ['tableHeader', 'tableCell']
					: [nodeType].includes(node.type.name)
			)(selection);

			return {
				borderStyle: currentCell?.node?.attrs?.borderStyle,
				currentSelection: selection,
				currentCell,
			};
		},
	});

	const handleChange = (e) => {
		if (nodeType === 'table') {
			editor.chain().focus().setCellAttribute('borderStyle', e.target.value).run();
		} else {
			editor.chain().focus().setDivAttribute('borderStyle', e.target.value).run();
		}
	};

	return (
		<ToolbarDropdown
			ref={ref}
			title='Border style'
			showSelection={true}
			defaultValue={borderStyle}
			fields={options}
			onChange={handleChange}
			sx={{
				width: '120px',
				pl: '4px',
			}}
			open={open}
			onOpen={() => setOpen(true)}
			onClose={() => setOpen(false)}
			startAdornment={
				<InputAdornment
					position='start'
					onClick={() => setOpen(true)}
					sx={{ cursor: 'pointer', mr: 0 }}
				>
					<BorderStyleIcon sx={{ mr: '4px' }} />
				</InputAdornment>
			}
		/>
	);
});
BorderSelect.displayName = 'BorderSelect';

export default BorderSelect;
